import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "../../node_modules/jquery/dist/jquery.min.js";

import Input from "../components/levty-ui/input";
import { getBase64 } from "../utils/files";
import {
  getCarrersAuthentication,
  isAuthenticatedCarrers,
  renewAccessToken,
  removeCarrersAuthentication,
} from "../utils/authentication";
import {
  getCampaignReferrer,
  setCampaignReferrer,
  getUrlParameter,
} from "../utils/referrer";
import Metatags from "../components/metatags";
import NavBar from "../components/navBar";
import LoadingButton from "../components/levty-ui/loadingButton";
import MessageModal from "../components/modals/messageModal";
import CarrerDataModal from "../components/modals/carrerDataModal";
import CarrerEmailTokenModal from "../components/modals/carrerEmailTokenModal";
import carrerService from "../services/carrerService";
import Footer from "../components/footer";
import SessionListener from "../utils/session-listener.js";

class DescricaoVaga extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allInputsValid: false,
      isAuthenticated: false,
      waitingEmailToken: false,
      spId: null,
      job: null,
      jsonld: null,
      campaign: null,
      file: null,
      fileName: "",
      fileError: false,
      isLoading: false,
      authName: null,
      authEmail: null,
      phoneNumber: "",
      accessToken: "",
      showMessagemModal: false,
      showSignUpModals: false,
      showErrorModal: false,
      showEmailErrorModal: false,
      errorMessage: "",
      inputs: {
        validations: {
          name: isAuthenticatedCarrers() && true,
          email: isAuthenticatedCarrers() && true,
          phoneNumber: false,
        },
      },
    };
  }
  async componentDidMount() {
    SessionListener.onInsertedItem((prop) => {
      if (prop === "carrersAuthentication") {
        window.location.reload();
      }
    });
    SessionListener.onGettingSession((prop) => {
      if (prop === "carrersAuthentication") {
        window.location.reload();
      }
    });
    SessionListener.askForSession();

    let error = getUrlParameter("error");
    if (error) {
      error === "No Email"
        ? this.setState({ isLoading: false, showEmailErrorModal: true })
        : this.setState({ isLoading: false, showErrorModal: true });
    } else if (getUrlParameter("accessToken")) {
      await renewAccessToken(getUrlParameter("accessToken"));
    }
    let Auth = getCarrersAuthentication();
    if (Auth) {
      this.setState({
        authName: Auth.name,
        authEmail: Auth.email,
        accessToken: Auth.accessToken,
      });
    }

    // verifica se chegou na pagina a partir de uma fonte de divulgacao
    const utmCampaign = getCampaignReferrer();
    if (utmCampaign) {
      this.setState({
        campaign: utmCampaign,
      });
    } else {
      const campaignName = getUrlParameter("utm_campaign");
      const campaignSource = getUrlParameter("utm_source");
      const campaignMedium = getUrlParameter("utm_medium");
      const campaignTerm = getUrlParameter("utm_term");
      const campaignContent = getUrlParameter("utm_content");
      if (campaignName && campaignSource) {
        const utmParams = {
          name: campaignName,
          source: campaignSource,
          medium: campaignMedium,
          term: campaignTerm,
          content: campaignContent,
        };
        setCampaignReferrer(utmParams);
        this.setState({
          campaign: utmParams,
        });
      }
    }

    try {
      const jobDescription = await this.getJobDescription();
      const jobDescriptionJsonld = await this.jobDescriptionJsonld();

      let lp = null;
      if (jobDescription?.divulgationToolsData?.length) {
        lp = jobDescription.divulgationToolsData[0];
      }

      sessionStorage.setItem("job", JSON.stringify(jobDescription));

      this.setState({
        spId: this.prepareSpId(),
        job: jobDescription,
        jsonld: jobDescriptionJsonld,
        isAuthenticated: isAuthenticatedCarrers(),
        lp: lp,
      });
    } catch {
      this.props.history.push("/404");
    }

    if (window.location.href.includes("?accessToken"))
      window.location.href = window.location.href.slice(
        0,
        window.location.href.indexOf("?accessToken")
      );

    await this.registerAnalysis();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isAuthenticated, phoneNumber, file, fileError } = this.state;

    // Verifica se o estado de autenticação mudou
    if (prevState.isAuthenticated !== isAuthenticated) {
      let Auth = getCarrersAuthentication();
      if (Auth) {
        this.setState({
          authName: Auth.name,
          authEmail: Auth.email,
          accessToken: Auth.accessToken,
        });
      }
    }

    let disableSubmitButton = false;
    const digitsPhone = phoneNumber.replace(/\D/g, "");

    // Lógica para desabilitar o botão de submit
    if (
      digitsPhone?.length === 10 ||
      (digitsPhone?.length === 11 && digitsPhone[2] !== "9") ||
      digitsPhone?.length < 10
    ) {
      disableSubmitButton = true;
    }

    if (!file) {
      disableSubmitButton = true;
    }

    if (fileError) {
      disableSubmitButton = true;
    }

    // Só chama setState se o valor de allInputsValid mudar
    if (prevState.allInputsValid !== disableSubmitButton) {
      this.setState({ allInputsValid: disableSubmitButton });
    }
  }

  async registerAnalysis() {
    try {
      const spId = this.prepareSpId();
      const data = {
        spId: spId,
      };

      const job = await carrerService.getJobDescription(data);
      await carrerService.registerAnalysis(
        "access",
        `/carreiras/vaga-${job.canonicalUrl}-${spId}`
      );
    } catch (e) { }
  }

  prepareSpId() {
    // Extrai o id da vaga
    let url = this.props.match.params.spId;

    if (url.length > 24) {
      let arrSplit = url.split("-");
      url = arrSplit[arrSplit.length - 1];
    }
    return url;
  }

  async getJobDescription() {
    const spId = this.prepareSpId();
    const data = {
      spId: spId,
    };

    const job = await carrerService.getJobDescription(data);
    return job;
  }

  async jobDescriptionJsonld() {
    const spId = this.prepareSpId();
    let data = {
      selectiveProcess: spId,
    };

    let jsonld = await carrerService.getJobJsonld(data);
    return JSON.stringify(jsonld, null, 4);
  }

  detailAccordion = (detail) => {
    return (
      <div translate="no" id="accordion">
        {detail.map((subDetail, indexSubDetail) => {
          return (
            <div
              translate="no"
              className="notranslate card mt-0 mb-2"
              key={indexSubDetail}
            >
              <div
                translate="no"
                className="notranslate card-header mt-0"
                id={`heading${indexSubDetail}`}
              >
                <h2 translate="no" className="notranslate h6 mb-0 mt-0">
                  <button
                    className="notranslate btn btn-link mt-0"
                    data-toggle="collapse"
                    data-target={`#collapse${indexSubDetail}`}
                    aria-expanded="false"
                    aria-controls={`collapse${indexSubDetail}`}
                  >
                    {subDetail.header}
                  </button>
                </h2>
              </div>
              <div
                translate="no"
                id={`collapse${indexSubDetail}`}
                className="notranslate collapse"
                aria-labelledby={`heading${indexSubDetail}`}
                data-parent="#accordion"
              >
                <div translate="no" className="notranslate card-body mt-0">
                  {subDetail.component === "p"
                    ? this.detailParagraph(subDetail)
                    : this.detailList(subDetail)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  detailParagraph = (detail) => {
    return (
      <>
        {detail.description !== null
          ? detail.description.map((item, index) => {
            return (
              <p
                translate="no"
                className="notranslate lev-job-detail-subtitle"
                key={index}
              >
                {item}
              </p>
            );
          })
          : ""}
      </>
    );
  };

  detailList = (detail) => {
    return (
      <ul>
        {detail.description !== null
          ? detail.description.map((item, index) => {
            return (
              <li className="notranslate with-icon" key={index}>
                {item}
              </li>
            );
          })
          : ""}
      </ul>
    );
  };

  // TODO: Unificar a função abaixo em um outro arquivo (utils), pois a mesma é utilizada em outras views (talento, por exemplo)
  handleFileInput = (e) => {
    const resumeFile = e.target.files[0];
    if (!resumeFile) return false;

    if (resumeFile) {
      this.setState({ fileName: resumeFile.name });
    }

    if (resumeFile) {
      let fileFormat = resumeFile.type;
      let fileSizeMB = resumeFile.size / (1024 * 1024);

      if (fileFormat !== "application/pdf") {
        this.setState({
          fileError: true,
          fileErrorMessage: "Formato de arquivo não suportado",
        });
        return false;
      }
      if (fileSizeMB > 5) {
        this.setState({
          fileError: true,
          fileErrorMessage: "Tamanho máximo do arquivo deverá ser 5MB",
        });
        return false;
      }

      this.setState({
        fileError: false,
        fileErrorMessage: "",
        file: resumeFile,
      });
      return true;
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    try {
      const {
        file,
        fileName,
        accessToken,
        spId,
        campaign,
        phoneNumber,
        authEmail,
        authName,
      } = this.state;

      if (!file) return;
      let data = {};

      if (file) {
        this.setState({ isLoading: true });
        const reader = new FileReader();
        reader.readAsDataURL(file);

        getBase64(file)
          .then(async (result) => {
            data = {
              resume: {
                name: fileName,
                base64: result,
              },
              email: authEmail,
              fullName: authName,
              phone: phoneNumber,
              accessToken: accessToken,
              selectiveProcess: spId,
              campaign: campaign,
            };

            let subscribeRequisition =
              await carrerService.selectiveProcessSubscribe(data);

            if (
              subscribeRequisition &&
              subscribeRequisition.result &&
              subscribeRequisition.result.status === 200
            ) {
              this.setState({ isLoading: false, showMessagemModal: true });
            } else {
              this.setState({
                isLoading: false,
                showErrorModal: true,
                errorMessage:
                  subscribeRequisition?.error?.response?.data?._messages[0]
                    ?.text || "Oops, algo deu errado desta vez.",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.setState({ isLoading: false });
          });
      }
    } catch {
      this.setState({ isLoading: false, showErrorModal: true });
    }
  };

  handleCloseDataModal = () => {
    this.setState({ showSignUpModals: false });
  };

  handleCloseTokenModal = () => {
    this.setState({
      isAuthenticated: isAuthenticatedCarrers(),
    });
    let Auth = getCarrersAuthentication();
    if (Auth && isAuthenticatedCarrers()) {
      this.setState({
        authName: Auth.name,
        authEmail: Auth.email,
        accessToken: Auth.accessToken,
        file: null,
        fileName: "Selecione seu currículo",
        waitingEmailToken: false,
        showSignUpModals: false,
      });
    } else {
      this.setState({
        showSignUpModals: true,
        waitingEmailToken: false,
      });
    }
  };

  handleEmailTokenModal = (value) => {
    this.setState({ waitingEmailToken: value });
  };

  handleCloseMessageModal = () => {
    this.setState({ showMessagemModal: false });
  };

  handleCloseErrorModal = () => {
    this.setState({ showErrorModal: false });
  };
  handleCloseErrorErrorModal = () => {
    this.setState({ showEmailErrorModal: false, showSignUpModals: true });
  };

  handleSignOut = () => {
    this.setState({
      showSignUpModals: true,
    });
    removeCarrersAuthentication();
  };

  handlePhoneNumberInput = (input, validation, value) => {
    this.setState({ phoneNumber: value });
  };

  render() {
    const {
      spId,
      job,
      lp,
      jsonld,
      authName,
      authEmail,
      fileName,
      fileError,
      fileErrorMessage,
      isLoading,
      showMessagemModal,
      isAuthenticated,
      waitingEmailToken,
      showSignUpModals,
      showErrorModal,
      showEmailErrorModal,
      phoneNumber,
      allInputsValid,
    } = this.state;

    return (
      <>
        <NavBar />
        <main>
          <div
            translate="no"
            className="notranslate lev-job-detail animated fadeIn slow"
          >
            <section className="notranslate lev-section-job-description">
              <div translate="no" className="notranslate container">
                <div
                  translate="no"
                  className="notranslate row justify-content-between"
                >
                  {job ? (
                    <>
                      <Metatags
                        title={`Vaga ${job.name} - ${job.city} | LEVTY`}
                        description={
                          !job.description
                            ? `Vagas ${job.name} em ${job.city} - ${job.state}`
                            : `${job.description}`
                        }
                        url={window.location.href}
                        canonical={`/carreiras/vaga-${job.canonicalUrl}-${spId}`}
                        jsonld={jsonld}
                      />

                      <div translate="no" className="notranslate col-lg-6">
                        <div
                          translate="no"
                          className="notranslate lev-job-detail-description"
                        >
                          <Link
                            className="notranslate btn btn-link lev-btn-link-back"
                            to="/carreiras/vagas"
                          >
                            Vagas abertas
                          </Link>
                        </div>
                        <h1
                          translate="no"
                          className="notranslate lev-job-detail-title"
                        >
                          {job.name}
                        </h1>
                        <p
                          translate="no"
                          className="notranslate lev-job-detail-subtitle"
                        >
                          {job.isRemoteJob
                            ? `Remoto`
                            : `${job.city}, ${job.state}`}
                          <span>&#8226;</span>
                          {job.quantity} {job.quantity === 1 ? "vaga" : "vagas"}
                        </p>
                        {job.description ? (
                          <>
                            <div
                              translate="no"
                              className="notranslate lev-job-section"
                            >
                              <h2>Descrição</h2>
                              <div
                                translate="no"
                                dangerouslySetInnerHTML={{
                                  __html: job.description,
                                }}
                              ></div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {job.jobDetails.map((detail, indexDetail) => {
                          return (
                            <div
                              translate="no"
                              className="notranslate lev-job-section"
                              key={indexDetail}
                            >
                              <h2 translate="no" className="notranslate h6">
                                {detail.header}
                              </h2>
                              {(() => {
                                switch (detail.component) {
                                  case "accordion":
                                    return this.detailAccordion(
                                      detail.accordionDetails
                                    );
                                  case "p":
                                    return this.detailParagraph(detail);
                                  default:
                                    return this.detailList(detail);
                                }
                              })()}
                            </div>
                          );
                        })}
                      </div>
                      <div translate="no" className="notranslate col-lg-4">
                        <p translate="no" className="notranslate h4">
                          Junte-se a nós
                        </p>
                        <p translate="no" className="notranslate mb-4">
                          Buscamos pessoas incríveis para fazer coisas
                          incríveis. Candidate-se para esta oportunidade.
                        </p>
                        {lp ? (
                          <LoadingButton
                            label="Próximo passo"
                            aditionalClass="primary sign-up"
                            onClick={() => {
                              const { campaign } = this.state;
                              let targetUrl = lp.data.url;
                              if (campaign && targetUrl) {
                                const params = new URLSearchParams();
                                if (campaign.name) params.append("utm_campaign", campaign.name);
                                if (campaign.source) params.append("utm_source", campaign.source);
                                if (campaign.medium) params.append("utm_medium", campaign.medium);
                                if (campaign.content) params.append("utm_content", campaign.content);
                                if (campaign.term) params.append("utm_term", campaign.term);
                                const queryString = params.toString();
                                if (queryString) {
                                  targetUrl += (targetUrl.includes('?') ? '&' : '?') + queryString;
                                }
                              }
                              window.open(
                                this.props.history.createHref({
                                  pathname: targetUrl,
                                }),
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }} // onClick={() => this.props.history.push(lp.data.url)}
                            type="button"
                          />
                        ) : isAuthenticated ? (
                          <>
                            <form
                              id="job-subscribe"
                              onSubmit={this.handleSubmit}
                            >
                              <h2
                                translate="no"
                                className="notranslate h5 mb-1"
                              >
                                Informações de contato
                              </h2>
                              <div
                                translate="no"
                                className="notranslate lev-rev-info-job"
                              >
                                <p
                                  translate="no"
                                  className="notranslate text-muted lev-form-subtitle"
                                >
                                  Revise suas informações pessoais.
                                </p>
                                <p
                                  translate="no"
                                  className="notranslate btn btn-sm btn-link"
                                  id="logout-button"
                                  onClick={this.handleSignOut}
                                >
                                  Alterar dados
                                </p>
                              </div>

                              <div
                                translate="no"
                                className="notranslate mb-3 form-group"
                              >
                                <Input
                                  id="name"
                                  label="Nome completo"
                                  type="text"
                                  backgroundColor="#E7E8EE"
                                  aditionalClass="form-control-lg"
                                  required={true}
                                  readOnly={true}
                                  callBackFunction={() => { }}
                                  value={authName}
                                />
                              </div>
                              <div
                                translate="no"
                                className="notranslate mb-3 form-group"
                              >
                                <Input
                                  id="email"
                                  label="Email"
                                  type="email"
                                  backgroundColor="#E7E8EE"
                                  aditionalClass="form-control-lg"
                                  required={true}
                                  readOnly={true}
                                  validationErrorMessage="Email inválido"
                                  callBackFunction={() => { }}
                                  value={authEmail}
                                />
                              </div>
                              <div
                                translate="no"
                                className="notranslate mb-4 form-group"
                              >
                                <Input
                                  id="phoneNumber"
                                  label="Telefone celular (WhatsApp)"
                                  type="tel"
                                  backgroundColor="#E7E8EE"
                                  aditionalClass="form-control-lg"
                                  required={true}
                                  readOnly={false}
                                  value={phoneNumber}
                                  mask="phoneWpp"
                                  callBackFunction={this.handlePhoneNumberInput}
                                  validationErrorMessage={
                                    "Número de celular inválido"
                                  }
                                  requiredErrorMessage={
                                    !allInputsValid
                                      ? ""
                                      : "Confira os dados informados"
                                  }
                                />
                              </div>

                              <h2
                                translate="no"
                                className="notranslate h5 mb-1"
                              >
                                Seu currículo
                              </h2>
                              <p
                                translate="no"
                                className="notranslate text-muted mb-3 lev-form-subtitle"
                              >
                                Envie seu currículo no formato PDF com no máximo
                                5 MB.
                              </p>
                              <div
                                translate="no"
                                className="notranslate lev-input-file-container pb-2 mb-4"
                              >
                                <input
                                  type="file"
                                  id="curriculum"
                                  name="curriculum"
                                  className="notranslate lev-input-group lev-input-file"
                                  onChange={this.handleFileInput}
                                />
                                <div
                                  translate="no"
                                  className="notranslate lev-input-wrapper d-flex align-items-center"
                                >
                                  <label
                                    htmlFor="curriculum"
                                    className="notranslate lev-input-file-trigger mb-0 mr-3"
                                  >
                                    <img
                                      className="notranslate lev-input-file-trigger-icon"
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/images/icons/attach_file.svg"
                                      }
                                      alt="LEVTY"
                                    />
                                  </label>
                                  <span
                                    translate="no"
                                    className="notranslate lev-input-file-return"
                                  >
                                    {fileName === ""
                                      ? "Selecione seu currículo"
                                      : fileName}
                                  </span>
                                </div>
                                {fileError ? (
                                  <span
                                    translate="no"
                                    className="notranslate lev-input-file-return"
                                    style={{ color: "red" }}
                                  >
                                    {fileErrorMessage}
                                  </span>
                                ) : null}
                              </div>

                              <LoadingButton
                                label="Finalizar candidatura"
                                aditionalClass="primary"
                                isLoading={isLoading}
                                // onlyDisable={!allInputsValid || !file /*|| (!file && !fileError)*/}
                                onlyDisable={allInputsValid}
                                type="submit"
                              />
                            </form>
                          </>
                        ) : (
                          <LoadingButton
                            label="Inscreva-se"
                            aditionalClass="primary sign-up"
                            onClick={() =>
                              this.setState({ showSignUpModals: true })
                            }
                            type="button"
                          />
                        )}
                      </div>
                    </>
                  ) : (
                    <div translate="no" className="notranslate col-lg-6">
                      <div translate="no" className={"lev-loading-test"}></div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        </main>
        {showSignUpModals && !waitingEmailToken && (
          <CarrerDataModal
            handleClose={this.handleCloseDataModal}
            handleEmailTokenModal={this.handleEmailTokenModal}
          />
        )}
        {showSignUpModals && waitingEmailToken && (
          <CarrerEmailTokenModal
            handleClose={this.handleCloseTokenModal}
            handleEmailTokenModal={this.handleEmailTokenModal}
          />
        )}
        {showMessagemModal && (
          <MessageModal
            title="Tudo certo!"
            subtitle="Currículo recebido com sucesso! Em caso de aprovação, entraremos em contato. Boa sorte!"
            buttonClass="primary"
            onClick={() => {
              window.location.pathname = "/";
            }}
          />
        )}
        {showErrorModal && (
          <MessageModal
            title="Oops!"
            subtitle={this.state.errorMessage}
            buttonClass="danger"
            onClick={this.handleCloseErrorModal}
          />
        )}
        {showEmailErrorModal && (
          <MessageModal
            title="Oops, esta conta não está vinculada a um e-mail. "
            subtitle="Entre com outra rede social ou com seu e-mail."
            buttonClass="danger"
            onClick={this.handleCloseErrorErrorModal}
          />
        )}
        <Footer />
      </>
    );
  }
}
export default DescricaoVaga;
